"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _FuturesOpenPositionsComponent = _interopRequireDefault(require("./FuturesOpenPositionsComponent"));
var _instrumentPositionSelectors = require("../../../redux/selectors/instrumentPositionSelectors");
var _selectors = require("../../../redux/futures/selectors");
var _modalActions = require("../../../redux/actions/modalActions");
var _productsSelectors = require("../../../redux/selectors/productsSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var openPositions = (0, _selectors.openPositionsSelector)(state);
  var instruments = (0, _instrumentPositionSelectors.instrumentSelectorInstruments)(state);
  var notionalProduct = (0, _productsSelectors.baseNotionalProductSelector)(state);
  var activeRequests = state.futures.positions.activeRequests;
  var fetching = activeRequests > 0;
  return {
    data: openPositions,
    instruments: instruments,
    notionalProduct: notionalProduct,
    fetching: fetching
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openAddEditTPSLModal: function openAddEditTPSLModal(position, mode) {
      return dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.FUTURES_ADD_EDIT_TPSL, {
        position: position,
        mode: mode
      }));
    },
    openClosePositionModal: function openClosePositionModal(position, mode) {
      return dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.FUTURES_CLOSE_POSITION, {
        position: position,
        mode: mode
      }));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FuturesOpenPositionsComponent["default"]);